<template>
      <vue-page-transition name="fade-in-down">
        <v-content class="mission-hub">
  <div class="mission-hub" :class="backgroundClass">
    <h3 class="title">🚀 Sales Mission Hub</h3>
        <div class="record-section">
          <v-btn @click="toggleRecording" :disabled="loading" class="record-button">
            {{ recording ? "⏹ Stop Recording" : "🎤 Start Recording" }}
          </v-btn>
          <span v-if="recording" class="recording-indicator">Recording...</span>
        </div>
        
    <!-- GRID LAYOUT -->  
    <div class="grid-container">
      <div class="grid-item">
        <!-- Call Recording Controls -->
          <h4>📜 Call Transcript</h4>
<v-divider></v-divider>
        <!-- Call Transcript -->
        <div v-if="transcript.length" class="transcript-box">

          <p v-for="(line, index) in transcript" :key="index" class="transcript-line">
            <strong class="speaker-name">{{ line.speaker }}:</strong> {{ line.text }}
          </p>
        </div>
      </div>
      <!-- 1st Row, 1st Column -->
      <div class="grid-item">
      
        <!-- Mission Hub Overview (Editable Form) -->
        <div class="mission-overview">
          <h4>📌 Mission Details</h4>
          <v-divider></v-divider>
          <label>Client:</label>
          <input v-model="clientName" type="text" class="input-field" placeholder="Enter Client Name" />
          
          <label>Company:</label>
          <input v-model="company" type="text" class="input-field" placeholder="Enter Company Name" />
          
          <label>Agent:</label>
          <input v-model="agent" type="text" class="input-field" />
          
          <label>Date:</label>
          <input v-model="callDate" type="date" class="input-field" />
          
          <label>Website:</label>
          <input v-model="website" type="url" class="input-field" placeholder="Company Website" />
          
          <label>Callback Date:</label>
          <input v-model="callbackDate" type="date" class="input-field" />
          
          <v-btn @click="saveCall" class="save-button">💾 Save Call</v-btn>
        </div>
        <!-- <p><strong>Client:</strong> {{ clientName || "Not Detected" }}</p>
<p><strong>Company:</strong> {{ company || "Not Detected" }}</p>
<p><strong>Agent:</strong> {{ agent }}</p>
<p><strong>Date:</strong> {{ callDate }}</p>
<p><strong>Website:</strong> <a v-if="website" :href="website" target="_blank">{{ website }}</a></p>
<p><strong>Callback Date:</strong> {{ callbackDate || "Not Scheduled" }}</p> -->

        <!-- Call Transcript -->
      </div>
      <div id="call-insights" class="grid-item full-width">
    <h4>🔍 Call Insights</h4>
    <v-divider></v-divider>
    
    <!-- AI Call Insights -->
    <div v-if="analysis" class="insight-box">
        <p><strong>Recommendation:</strong> {{ analysis.recommendation }}</p>
        <p><strong>Interest Score:</strong> {{ analysis.interestScore }}/10</p>
        <p><strong>Overall Grade:</strong> {{ analysis.grade }}</p>
    </div>
</div>


      <!-- 1st Row, 2nd Column -->

      <div class="grid-item full-width">   
                      <!-- AI Task List -->
<div class="task-section">
  <h4>✅ Mission Tasks</h4>
  <ul>
    <li v-for="(task, index) in tasks" :key="index" class="task-item">
      <input type="checkbox" v-model="task.completed" @change="updateTaskStatus(task)" />
      <span :class="{ completed: task.completed }">{{ task.step }}</span>
      <v-btn v-if="!task.completed" @click="executeTask(task)" class="task-button">Execute Task</v-btn>
      
      <div v-if="task.content" class="task-content">
        <textarea v-model="task.content" class="task-textarea"></textarea>
        <v-btn @click="saveTaskState">💾 Save</v-btn>
      </div>
    </li>
  </ul>
</div>
      </div>

      <!-- 2nd Row - Follow-up Email -->
      <div id="follow-up" class="grid-item full-width">
        <h4>📧 Follow-up Email</h4>
        <v-divider></v-divider>
        <textarea v-model="followUpEmail" class="email-textarea"></textarea>
        <!-- <v-btn @click="syncEmail" class="sync-button">Sync to CRM</v-btn>
          -->
          <v-btn @click="saveCall" class="save-button">💾 Save Call</v-btn>
      </div>

<!-- 3rd Row - Saved Calls Gallery -->
<div class="grid-item full-width">
    <h4>📁 Saved Calls</h4>
    <v-divider></v-divider>

    <div class="saved-calls-grid">
        <div v-for="(call, index) in savedCalls" :key="index" class="saved-call-card">
            <div class="call-header">
                <h5>{{ call.clientName || "Unknown Client" }}</h5>
                <p class="call-date">{{ call.callDate || "No Date" }}</p>
            </div>
            <p><strong>Company:</strong> {{ call.company || "Not Specified" }}</p>
            <p><strong>Agent:</strong> {{ call.agent || "Unknown Agent" }}</p>
            <p><strong>Callback:</strong> {{ call.callbackDate || "Not Scheduled" }}</p>

            <div class="call-actions">
                <v-btn @click="editCall(index)" class="edit-button">✏️ Edit</v-btn>
                <v-btn @click="deleteCall(index)" class="delete-button">🗑 Delete</v-btn>
            </div>
        </div>
    </div>
</div>

    </div>
  </div>
</v-content>
</vue-page-transition>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      recording: false,
      transcript: [],
      analysis: null,
      tasks: [],
      completedTasks: [],
      followUpEmail: "",
      recognition: null,
      savedCalls: JSON.parse(localStorage.getItem("savedCalls")) || [],
      mediaRecorder: null,
      clientName: "",
      company: "",
      backgroundClass: "default-bg",
      taskCompleted: false,
      agent: "Sales Agent",
      callDate: new Date().toLocaleDateString(),
      website: "",
      callbackDate: "",
      gptApiKey: "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", // Replace with your OpenAI API key
    };
  },
  methods: {
    toggleRecording() {
      if (!this.recording) {
        this.startRecording();
      } else {
        this.stopRecording();
      }
    },

    startRecording() {
      this.recording = true;
      this.updateBackground("red");
      navigator.mediaDevices.getUserMedia({ audio: true })
        .then((stream) => {
          this.mediaRecorder = new MediaRecorder(stream);
          this.audioChunks = [];

          this.mediaRecorder.ondataavailable = (event) => {
            if (event.data.size > 1) {
              this.audioChunks.push(event.data);
            }
          };

          this.mediaRecorder.onstop = this.processRecording;
          this.mediaRecorder.start();
          this.startSpeechRecognition();
        })
        .catch((error) => {
          console.error("Error accessing microphone:", error);
        });
    },

    stopRecording() {
      this.recording = false;
      this.mediaRecorder.stop();
      this.stopSpeechRecognition();
    },

    startSpeechRecognition() {
    navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: true, noiseSuppression: true, sampleRate: 44100 } })
        .then(() => {
            this.recognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
            this.recognition.continuous = true;
            this.recognition.interimResults = false; // Only capture finalized speech
            this.recognition.lang = "en-US";

            this.recognition.onresult = (event) => {
                const results = event.results;
                let lastResult = results[results.length - 1];

                if (lastResult.isFinal) {
                    let text = lastResult[0].transcript.trim();
                    let speaker = this.identifySpeaker(text);

                    this.transcript.push({ speaker, text });

                    // Auto-extract relevant details from conversation
                    this.extractFormData(text, speaker);

                    // Update background color based on speaker
                    this.updateBackground(speaker === "Agent" ? "blue" : "green");
                }
            };

            this.recognition.start();
        })
        .catch((error) => {
            console.error("Error accessing microphone and system audio:", error);
        });
},

extractFormData(text) {
    // Extract Client Name
    let clientMatch = text.match(/(?:speak to|talk to|looking for|is this|this is)\s([A-Z][a-z]+(?:\s[A-Z][a-z]+)?)/);
    if (clientMatch && !this.clientName) {
        this.clientName = clientMatch[1]; // Extracted client name
    }

    // Extract Company Name
    let companyMatch = text.match(/(?:from|representing|working with|at)\s([A-Z][a-z]+(?:\s[A-Z][a-z]+)?)/);
    if (companyMatch && !this.company) {
        this.company = companyMatch[1]; // Extracted company name
    }

    // Extract Website
    let websiteMatch = text.match(/\b(?:www\.|https?:\/\/)?[a-zA-Z0-9.-]+\.(com|net|org|io|ai|biz)\b/);
    if (websiteMatch && !this.website) {
        this.website = websiteMatch[0].startsWith("http") ? websiteMatch[0] : `https://${websiteMatch[0]}`;
    }

    // Extract Callback Date
    let dateMatch = text.match(/\b(?:on|by|around|next)\s(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday|\d{1,2}(?:st|nd|rd|th)?(?:\s\w+)?(?:\s\d{4})?)\b/);
    if (dateMatch && !this.callbackDate) {
        this.callbackDate = dateMatch[0];
    }

    // Save updated form data
    // this.saveCall();
},

identifySpeaker(text) {
  const agentPhrases = [
    // Introductions & Greetings
    "Hello, this is", "calling from", "I'm reaching out", 
    "How are you today", "May I speak with", "I’d like to talk about",
    "Hi, am I speaking with", "Good morning", "Good afternoon", "Good evening",

    // Sales & Pitch
    "I wanted to introduce you to", "We offer a great solution for", 
    "Have you heard about", "Our company specializes in", 
    "Many businesses like yours benefit from", "Let me explain how it works",
    "This could be a game-changer for", "We are currently running a promotion on",
    "Our service helps businesses with", "You might be interested in",

    // Qualifying the Lead
    "Do you currently use", "Are you the decision-maker for",
    "What are you currently using for", "Do you have a moment to discuss",
    "Can I ask how you're handling", "What are your main challenges with",
    "How satisfied are you with", "Is this something you’d be open to learning more about?",
    
    // Handling Objections
    "I understand, but have you considered", "Many of our customers felt the same way until",
    "I hear you, but let me show you how we’re different",
    "I completely understand, let me explain", 
    "I know time is valuable, but this will only take a minute",
    "If cost is a concern, we do have flexible options",
    "I understand you’re busy, when would be a better time?",

    // Scheduling & Follow-up
    "Would you be available for a quick demo?", "Can we set up a call next week?",
    "I’d love to schedule a follow-up meeting", "I can send you some information",
    "Can I follow up with you next week?", "Would you like me to send you an email with details?",

    // Closing the Sale
    "Let’s get you started today", "We can set you up right now",
    "How soon would you like to move forward?", "I can process this for you immediately",
    "What’s stopping you from trying this today?", "If you sign up now, we can offer you",
    "We’re happy to offer a free trial", "Would you like to take advantage of this offer?",
];

    
const clientPhrases = [
    // Initial Responses
    "Yes, this is", "What is this call about?", "How can I help?", 
    "Who is this?", "Why are you calling me?", "I wasn’t expecting a call.", 
    "I don’t remember signing up for this.", "How did you get my number?", 
    "I’m in the middle of something right now.", "Sorry, I’m busy.", 

    // Interest & Inquiry
    "Tell me more.", "Can you explain?", "How does this work?", 
    "What does your company do?", "I’ve heard of this before.", 
    "I’m interested, but I need more details.", "What’s included in this offer?",
    "How much does it cost?", "Do you have any discounts?", "Is there a trial period?", 
    "How is this different from other options?", "Do you have any case studies or reviews?",

    // Objections & Hesitations
    "I’m not interested.", "I don’t have the budget for this.", 
    "I already have a solution for this.", "I need to talk to my team first.",
    "We’re not looking for this right now.", "Can you send me some information instead?",
    "I don’t make these decisions.", "I’m happy with my current provider.", 
    "I need to think about it.", "I’ll call you if I’m interested.",

    // Follow-up & Scheduling
    "Can you call me back later?", "I need some time to review this.", 
    "Can we schedule a follow-up?", "Can you send me an email with more details?",
    "I’d like to discuss this with my boss first.", "I’ll need approval from my manager.",
    "Can I see a demo before committing?", "Is this available online?", 

    // Closing & Final Decisions
    "Okay, let’s proceed.", "I’d like to move forward with this.", 
    "I have a few final questions before signing up.", "How do I get started?",
    "What’s the next step?", "Can we finalize this today?",
    "I’ll need a contract to review.", "Do you have a cancellation policy?", 
    "What’s the setup process like?", "Will I get support after signing up?"
];

    // If no client has spoken yet, assume the first speaker is the Agent
    if (this.transcript.length === 0) return "Agent";

    // Check if the text matches common agent or client phrases
    if (agentPhrases.some(phrase => text.includes(phrase))) return "Agent";
    if (clientPhrases.some(phrase => text.includes(phrase))) return "Client";

    // If it's the second speaker and different from the first, assume it's the client
    if (this.transcript.length === 1 && this.transcript[0].speaker === "Agent") return "Client";

    // Default to the last identified speaker to maintain consistency
    return this.transcript.length > 0 ? this.transcript[this.transcript.length - 1].speaker : "Agent";
},

    processRecording() {
      this.updateBackground("dark-blue");
      this.analyzeCall();
    },

    updateBackground(color) {
      this.backgroundClass = color;
    },

    // async analyzeCall() {
    //   this.updateBackground("dark-green");

    //   try {
    //     let transcriptText = this.transcript.map(t => `${t.speaker}: ${t.text}`).join("\n");

    //     let response = await axios.post("https://api.openai.com/v1/chat/completions", {
    //       model: "gpt-4o",
    //       messages: [{ role: "user", content: `Analyze this sales call transcript and provide recommendations:\n${transcriptText}` }],
    //       max_tokens: 1000,
    //       temperature: 0.4,
    //     }, {
    //       headers: {
    //         Authorization: `Bearer ${this.gptApiKey}`,
    //         "Content-Type": "application/json",
    //       },
    //     });

    //     let analysisText = response.data.choices[0].message.content.trim();
    //     this.analysis = {
    //       recommendation: analysisText.split("\n")[0],
    //       interestScore: Math.floor(Math.random() * 10) + 1,
    //       grade: ["A", "B", "C", "D"][Math.floor(Math.random() * 4)],
    //     };

    //     this.generateFollowUp();
    //     this.generateTaskList();
    //   } catch (error) {
    //     console.error("Error analyzing call:", error);
    //   }
    // },

    async analyzeCall() {
    this.updateBackground("dark-green");

    try {
        let transcriptText = this.transcript.map(t => `${t.speaker}: ${t.text}`).join("\n");

        let response = await axios.post("https://api.openai.com/v1/chat/completions", {
            model: "gpt-4o",
            messages: [{ role: "user", content: `Analyze this sales call transcript and provide recommendations:\n${transcriptText}` }],
            max_tokens: 1000,
            temperature: 0.4,
        }, {
            headers: {
                Authorization: `Bearer ${this.gptApiKey}`,
                "Content-Type": "application/json",
            },
        });

        let analysisText = response.data.choices[0].message.content.trim();
        this.analysis = {
            recommendation: analysisText.split("\n")[0],
            interestScore: Math.floor(Math.random() * 10) + 1,
            grade: ["A", "B", "C", "D"][Math.floor(Math.random() * 4)],
        };

        // Wait for the DOM to update, then scroll to the insights section
        this.$nextTick(() => {
            this.scrollToInsights();
        });

        setTimeout(() => {
             this.generateFollowUp();
        this.$nextTick(() => {
            this.scrollToFollowup();
        });
        }, 8000);
        this.generateTaskList();
    } catch (error) {
        console.error("Error analyzing call:", error);
    }
},

scrollToInsights() {
    const insightsSection = document.getElementById("call-insights");
    if (insightsSection) {
        insightsSection.scrollIntoView({ behavior: "smooth", block: "start" });
    }
}, 
scrollToFollowup() {
    const followUpSection = document.getElementById("follow-up");
    if (followUpSection) {
        followUpSection.scrollIntoView({ behavior: "smooth", block: "start" });
    }
},

    async generateFollowUp() {
      let response = await axios.post("https://api.openai.com/v1/chat/completions", {
        model: "gpt-4o",
        messages: [{ role: "user", content: `Generate a follow-up email for this sales call:\n${this.transcript.map(t => t.text).join(" ")}\nBased on the analysis:\n${this.analysis.recommendation}` }],
        max_tokens: 500,
        temperature: 0.5,
      }, {
        headers: {
          Authorization: `Bearer ${this.gptApiKey}`,
          "Content-Type": "application/json",
        },
      });

      this.followUpEmail = response.data.choices[0].message.content.trim();
    },

    generateTaskList() {
        this.tasks = [
            { step: "📧 Email", completed: false, content: "" },
            { step: "📜 Script", completed: false, content: "" },
            { step: "📑 Proposal", completed: false, content: "" },
            { step: "📅 Appointment", completed: false, content: "" },
            { step: "🔍 Insights", completed: false, content: "" },
            { step: "💬 Follow-Up", completed: false, content: "" },
        ];
    },

    async executeTask(task) {
        task.completed = true;
        this.updateTaskStatus(task);

        let prompt = this.getTaskPrompt(task.step);
        if (!prompt) return;

        try {
            let response = await axios.post("https://api.openai.com/v1/chat/completions", {
                model: "gpt-4o",
                messages: [{ role: "user", content: prompt }],
                max_tokens: 500,
                temperature: 0.6,
            }, {
                headers: {
                    Authorization: `Bearer ${this.gptApiKey}`,
                    "Content-Type": "application/json",
                },
            });

            task.content = response.data.choices[0].message.content.trim();
            this.saveTaskState();
        } catch (error) {
            console.error(`Error executing task "${task.step}":`, error);
        }
    },

    updateTaskStatus(task) {
        console.log(`Task "${task.step}" marked as ${task.completed ? "completed" : "pending"}`);
        this.saveTaskState();
    },

    getTaskPrompt(step) {
        switch (step) {
            case "📧 Email":
                return `Generate a professional follow-up email for a sales call. Include client name: ${this.clientName}, company: ${this.company}, and call date: ${this.callDate}.`;
            case "📜 Script":
                return `Create a persuasive sales script for a potential client. The client's company is ${this.company}, and they are interested in our services.`;
            case "📑 Proposal":
                return `Draft a proposal for ${this.clientName} at ${this.company}, detailing the benefits of our service and pricing options.`;
            case "📅 Appointment":
                return `Generate a polite email to schedule a follow-up meeting with ${this.clientName} at ${this.company}.`;
            case "🔍 Insights":
                return `Summarize insights from a sales call with ${this.clientName} at ${this.company}. Include key points and recommendations.`;
            case "💬 Follow-Up":
                return `Write a brief but engaging follow-up message for ${this.clientName} at ${this.company} to maintain engagement.`;
            default:
                return "";
        }
    },
    saveTaskState() {
        localStorage.setItem("task", JSON.stringify(this.tasks));
    },

    loadTaskState() {
        let savedTasks = JSON.parse(localStorage.getItem("task"));
        if (savedTasks) {
            this.tasks = savedTasks;
        }
    },
    saveCall() {
        const newCall = {
            clientName: this.clientName,
            company: this.company,
            agent: this.agent,
            callDate: this.callDate,
            callbackDate: this.callbackDate,
        };

        this.savedCalls.push(newCall);
        localStorage.setItem("savedCalls", JSON.stringify(this.savedCalls));
    },


    editCall(index) {
        const call = this.savedCalls[index];
        this.clientName = call.clientName;
        this.company = call.company;
        this.agent = call.agent;
        this.callDate = call.callDate;
        this.callbackDate = call.callbackDate;
    },


    deleteCall(index) {
        this.savedCalls.splice(index, 1);
        localStorage.setItem("savedCalls", JSON.stringify(this.savedCalls));
},

    syncEmail() {
      alert("Follow-up email synced with CRM!");
    },
  },
  mounted() {
    this.loadTaskState();
},
};
</script>

<style>
.bg-content {
  background: #0a0f29;
  color: #ffffff;
  font-family: 'Poppins', sans-serif;
  transition: background-color 0.5s ease-in-out;
  width: 100%;
  height: 100%;
  padding: 30px 30px 30px 30px;
  margin-top: -50px;
  transition: background-color 0.5s ease-in-out;
}
.saved-calls-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); /* Responsive grid */
    gap: 15px;
    padding: 15px;
}

.saved-call-card {
    background: rgba(255, 255, 255, 0.08);
    border-radius: 10px;
    padding: 15px;
    box-shadow: 0 0 10px rgba(0, 204, 255, 0.2);
    transition: transform 0.2s ease-in-out;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.saved-call-card:hover {
    transform: scale(1.03);
}

.call-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    padding-bottom: 8px;
    margin-bottom: 10px;
}

.call-date {
    font-size: 0.85rem;
    color: rgba(255, 255, 255, 0.7);
}

.call-actions {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
}

.edit-button {
    background: #42a5f5;
    color: white;
    border-radius: 8px;
    padding: 5px 10px;
    transition: background 0.3s;
}

.edit-button:hover {
    background: #3a94d8;
}

.delete-button {
    background: #e53935;
    color: white;
    border-radius: 8px;
    padding: 5px 10px;
    transition: background 0.3s;
}

.delete-button:hover {
    background: #c62828;
}

.mission-hub {
  display: flex;
  flex-direction: column;
  gap: 20px;
  background: #454d77;
  color: #ffffff;
  font-family: 'Poppins', sans-serif;
  transition: background-color 0.5s ease-in-out;
  width: 100%;
  height: 100%;
  padding: 0px 80px 100px 80px;

  transition: background-color 0.5s ease-in-out;
}

.blue { background-color: #42a5f5; }
.green { background-color: #4caf50; }
.dark-blue { background-color: #0a0f29; }
.title {
  font-size: 1.8rem;
  text-align: center;
  margin-bottom: 20px;
  color: #ffffff;
}

/* Grid Layout */
.grid-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
  grid-template-rows: auto auto auto;
}

.grid-item {
  background: rgba(255, 255, 255, 0.05);
  padding: 15px;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 204, 255, 0.2);
}
.full-width {
  grid-column: span 2;
}

.input-field {
  width: 100%;
  padding: 8px;
  margin: 5px 0;
  background: #1A2335;
  border: none;
  color: white;
  height: 100%;
}

.email-textarea {
  width: 100%;
  padding: 8px;
  margin: 5px 0;
  background: #1A2335;
  border: none;
  color: white;

}
.gtif-item .full-width {
  grid-column: span 2;
  padding: 20px 20px ;
}
.task-item { display: flex; }
.task-content {
  margin-top: 10px;
  padding: 20px 20px 20px 20px;
  margin: 20px 20px 20px 20px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 5px;
  width: 100%;
}

.task-textarea {
  width: 100%;
  min-height: 150px;
  padding: 5px;
  background: #1A2335;
  border: none;
  color: white;
  resize: vertical;
}

/* Recording Section */
.record-section {
  text-align: center;
  margin-bottom: 20px;
}

.record-button {
  background: #4db5ff;
  color: white;
  border-radius: 8px;
  padding: 10px 15px;
  cursor: pointer;
  transition: background 0.3s;
}

.record-button:hover {
  background: #3a94d8;
}

/* Transcript & Scroll Effect */
.transcript-box {
  height: 650px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #4db5ff transparent;
}
.saved-calls {
  height: 100%;
  width: 100%;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #4db5ff transparent;
  display: flex;
  flex-direction: column;
  gap: 10px;

}
/* Task Section */
.task-section ul {
  list-style: none;
  padding: 0;
}

.task-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.task-button {
  background: #00cc99;
  color: white;
  margin-left: 10px;
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
}

.task-button:hover {
  background: #009977;
}

.completed {
  text-decoration: line-through;
  color: #888;
}

/* Task Completion Animation */
.task-complete-animation {
  position: fixed;
  top: 20%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #42a5f5;
  padding: 15px;
  border-radius: 8px;
  font-size: 18px;
  animation: fadeOut 2s ease-in-out;
}

@keyframes fadeOut {
  0% { opacity: 1; }
  100% { opacity: 0; }
}

/* AI Insights Box */
.insight-box {
  background: rgba(0, 204, 255, 0.1);
  border-left: 4px solid #4db5ff;
  padding: 15px 15px 15px 20px;
}

/* Scrollable Sections */
.scroll-box {
  max-height: 200px;
  overflow-y: auto;
  padding: 10px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 5px;
}
.chat-container {
  width: 100%;
  height: 100vh;
  padding: 20px;
  transition: background-color 0.5s ease-in-out;
}

.blue { background-color: #42a5f5; }
.green { background-color: #4caf50; }
.dark-blue { background-color: #0a0f29; }
.task-complete-animation {
  position: fixed;
  top: 20%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #42a5f5;
  padding: 15px;
  border-radius: 8px;
  font-size: 18px;
  animation: fadeOut 2s ease-in-out;
}

@keyframes fadeOut {
  0% { opacity: 1; }
  100% { opacity: 0; }
}
</style>
